import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from "../guards/auth.guard";
import {AssetsComponent} from "./assets.component";
import {AssetsImporterComponent} from "./assets-importer/assets-importer.component";

const routes: Routes = [
  {
    path: 'asset-register',
    component: AssetsComponent,
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'asset-register/importer',
    component: AssetsImporterComponent,
    canActivate: [
      AuthGuard
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetsRoutingModule { }
